import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SendIcon } from 'lucide-react';
import { LoanShell } from '../components/loan/LoanShell';
import { usePortal } from '../contexts/PortalContext';
import { loanOfficer, processor } from '../data/team';
import { useTokens } from '../hooks/useTokens';
export function Messages() {
  const {
    messages,
    sendMessage,
    answers
  } = usePortal();
  const [text, setText] = useState('');
  const {
    fill
  } = useTokens();
  const endRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    endRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'end'
    });
  }, [messages.length]);
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim()) return;
    sendMessage(text.trim());
    setText('');
  };
  return <LoanShell data-id="element-1004" data-mp="2mly6azq32flg">
      <main className="mx-auto flex max-w-3xl flex-col px-5 pt-8 md:px-8 md:pt-12" data-id="element-1005" data-mp="2mlekv918592o">
        <div className="flex items-center justify-between gap-4" data-id="element-1006" data-mp="2ilno8op0nyq8">
          <div data-id="element-1007" data-mp="xpyqzzid61l8">
            <h1 className="text-[28px] font-semibold tracking-[-0.03em] text-ink-900 md:text-[36px]" data-id="element-1008" data-mp="xofduhs086no">Messages</h1>
            <p className="mt-1 text-ink-500" data-id="element-1009" data-mp="12mgwj1liq3ym">Your loan team usually replies within a few hours.</p>
          </div>
          <div className="flex -space-x-2" data-id="element-1010" data-mp="17h3752jrzshn">
            {[loanOfficer, processor].map(p => <img key={p.name} src={p.photo} alt={p.name} className="h-10 w-10 rounded-full object-cover ring-2 ring-canvas" data-id="element-1011" data-mp="1cg60vqub2cab" />)}
          </div>
        </div>

        <ol className="mt-10 space-y-6" aria-live="polite" data-id="element-1012" data-mp="jq7c7wk0wh66">
          <AnimatePresence initial={false} data-id="element-1013" data-mp="onzcbdutn9lg">
            {messages.map(m => {
            const mine = m.author === 'borrower';
            const p = m.author === 'processor' ? processor : loanOfficer;
            return <motion.li key={m.id} initial={{
              opacity: 0,
              y: 8
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className={`flex gap-3 ${mine ? 'flex-row-reverse' : ''}`} data-id="element-1014" data-mp="202w3ouehaavz">
                  {!mine && <img src={p.photo} alt="" className="h-8 w-8 shrink-0 rounded-full object-cover" data-id="element-1015" data-mp="52lv4b3q2v7c" />}
                  <div className={`max-w-[80%] ${mine ? 'text-right' : ''}`} data-id="element-1016" data-mp="3itl0myb744">
                    <p className="mb-1 text-xs text-ink-400" data-id="element-1017" data-mp="e0nvqpjjnlu3">
                      {mine ? answers.firstName : p.name} · {m.time}
                    </p>
                    <p className={`inline-block rounded-2xl px-4 py-3 text-left text-[15px] leading-relaxed ${mine ? 'rounded-tr-md bg-pulse-600 text-white' : 'rounded-tl-md bg-white text-ink-900 ring-1 ring-ink-200'}`} data-id="element-1018" data-mp="3iew2vt0jv15p">{fill(m.body)}</p>
                  </div>
                </motion.li>;
          })}
          </AnimatePresence>
        </ol>
        <div ref={endRef} data-id="element-1019" data-mp="3mewez706f09l" />

        <form onSubmit={submit} className="sticky bottom-24 mt-10 flex items-end gap-2 rounded-2xl bg-white p-2 shadow-lift ring-1 ring-ink-200 md:bottom-6" data-id="element-1020" data-mp="2yr6hc3j7hx4x">
          <label htmlFor="msg" className="sr-only" data-id="element-1021" data-mp="2upkvvtslwaj4">
            Message your loan team
          </label>
          <textarea id="msg" rows={1} value={text} onChange={e => setText(e.target.value)} onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) submit(e);
        }} placeholder={`Message ${loanOfficer.firstName} and ${processor.firstName}`} className="max-h-32 min-h-[44px] flex-1 resize-none bg-transparent px-3 py-2.5 text-[15px] placeholder:text-ink-400 focus:outline-none" data-id="element-1022" data-mp="2kklbclehm1j8" />
          <button type="submit" disabled={!text.trim()} className="grid h-11 w-11 place-items-center rounded-xl bg-pulse-600 text-white transition-[background-color,opacity] duration-150 hover:bg-pulse-700 disabled:opacity-40" aria-label="Send" data-id="element-1023" data-mp="38apc8l0ajn6j">
            <SendIcon className="h-4 w-4" data-id="element-1024" data-mp="1hyjf35ql3fkr" />
          </button>
        </form>
        <div className="h-8" data-id="element-1025" data-mp="1my4etidkvryj" />
      </main>
    </LoanShell>;
}